import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let backgroundExample = `for host in web1 web2 web3; do
    ssh "$host" "systemctl restart app" &
done
wait   # block until every backgrounded job above has finished
echo "all restarts done"`

let xargsExample = `# Run up to 4 downloads at once
cat urls.txt | xargs -P 4 -I{} curl -sO {}

# find + xargs, null-delimited to survive filenames with spaces
find . -name "*.log" -print0 | xargs -0 -P 4 -I{} gzip {}`

let parallelExample = `# GNU parallel: similar goal, more features (progress bar, retries, ETA)
parallel -j4 curl -sO {} :::: urls.txt`

export default function ParallelExecution() {
    return (
        <div className={globalStyles.article}>
            <h1>Parallel execution</h1>
            <p>Bash has no built-in thread pool, but a few patterns cover most "do N things at once" needs.</p>

            <h3>Background + wait</h3>
            <p>Simplest option for a small, known set of tasks — no external tools required.</p>
            <SyntaxHighlighter
                children={backgroundExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <p>Caveat: this fires all jobs at once with no concurrency limit — fine for 3 hosts, risky for
                3,000.</p>

            <h3>xargs -P</h3>
            <p>Bounded concurrency for a stream of inputs — the go-to for "run this command over a list of
                items, N at a time".</p>
            <SyntaxHighlighter
                children={xargsExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>GNU parallel</h3>
            <p>Worth installing when you need retries, a progress indicator, or output kept from interleaving
                between jobs — not installed by default on most distros.</p>
            <SyntaxHighlighter
                children={parallelExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
